import { render } from "./wangeditorEditComp.vue?vue&type=template&id=6a55d808&scoped=true"
import script from "./wangeditorEditComp.vue?vue&type=script&lang=js"
export * from "./wangeditorEditComp.vue?vue&type=script&lang=js"

import "./wangeditorEditComp.vue?vue&type=style&index=0&id=6a55d808&scoped=true&lang=css"

import exportComponent from "F:\\workspace_2022\\ZhaiJiDi\\QT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a55d808"]])

export default __exports__